import { noop } from './function';

type NewPromise = {|
  promise: Promise<void>,
  resolve: any => void,
|};
export const noopPromise = () => Promise.resolve();

export const createNewPromise = (): NewPromise => {
  let resolveLocal = noop;
  const promise = new Promise(resolve => {
    resolveLocal = resolve;
  });

  return {
    promise,
    resolve: resolveLocal,
  };
};

export const postpone = (delay = 1000) =>
  new Promise(resolve => {
    setTimeout(resolve, delay);
  });
